"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortableDataGrid = void 0;
var widgets_datagrid_1 = require("@tableau/widgets-datagrid");
var React = require("react");
var arrow_down_closed_14px_small_1 = require("../../img/arrow_down_closed_14px-small");
var arrow_up_closed_14px_small_1 = require("../../img/arrow_up_closed_14px-small");
var ModelResultStyles_1 = require("../../styles/ModelResultStyles");
var SortableDataGrid = /** @class */ (function (_super) {
    __extends(SortableDataGrid, _super);
    // Take dataGridProps make a copy and place in state, and modify copy of props with our data
    function SortableDataGrid(props) {
        var _this = _super.call(this, props) || this;
        _this.selectionModel = new widgets_datagrid_1.RowKeyedGridSelection();
        var dataGridProps = Object.assign({}, props.dataGridProps);
        _this.updateDataGridProps(dataGridProps);
        _this.state = { dataGridProps: dataGridProps };
        return _this;
    }
    SortableDataGrid.prototype.updateDataGridProps = function (dataGridProps) {
        var _this = this;
        dataGridProps.onHeaderClick = this.headerClicked.bind(this);
        dataGridProps.cols.forEach(function (column) {
            column.headerComponent = _this.DataGridHeader.bind(_this);
        });
        if (dataGridProps.sortKey) {
            this.props.dataGridRowSorter(dataGridProps.rowStore['rows'], dataGridProps.sortKey, true);
        }
        if (this.props.dataGridSelection) {
            dataGridProps.selectionModel = this.selectionModel;
            dataGridProps.onSelectionEvent = this.handleSelectionEvent.bind(this);
        }
    };
    SortableDataGrid.prototype.handleSelectionEvent = function (e) {
        if (e.cell.rowIdx < 0 || this.selectionModel.isSelected(e.cell)) {
            return false; // row is already selected
        }
        this.selectionModel.clearSelection();
        this.selectionModel.toggleRowSelect(e.cell.rowKey, true);
        if (this.props.dataGridSelection) {
            this.props.dataGridSelection(e.cell.rowKey);
        }
        return true;
    };
    // Can be called from the parent to update the rows of the datagrid
    SortableDataGrid.prototype.updateDataGridRows = function (rows) {
        var _this = this;
        this.setState(function (prevState) {
            var newState = Object.assign({}, prevState);
            if (_this.props.dataGridRowSorter && newState.dataGridProps.sortKey) {
                var newRows = _this.props.dataGridRowSorter(rows, newState.dataGridProps.sortKey, newState.dataGridProps.sortAscending);
                newState.dataGridProps.rowStore = new widgets_datagrid_1.ArrayRowStore(newRows);
            }
            return newState;
        });
    };
    // When the header is clicked, resort the datagrid
    SortableDataGrid.prototype.headerClicked = function (rowData, cell) {
        var _this = this;
        if (this.props.dataGridSelection) {
            this.selectionModel.clearSelection();
        }
        this.setState(function (prevState) {
            var newState = Object.assign({}, prevState);
            if (cell.colKey !== newState.dataGridProps.sortKey) {
                newState.dataGridProps.sortKey = cell.colKey;
                newState.dataGridProps.sortAscending = true;
            }
            else {
                newState.dataGridProps.sortAscending = !newState.dataGridProps.sortAscending;
            }
            if (newState.dataGridProps.sortKey) {
                newState.dataGridProps.rowStore = new widgets_datagrid_1.ArrayRowStore(_this.props.dataGridRowSorter(newState.dataGridProps.rowStore['rows'], newState.dataGridProps.sortKey, newState.dataGridProps.sortAscending));
            }
            return newState;
        });
    };
    // Custom renderer for data grid header
    SortableDataGrid.prototype.DataGridHeader = function (props) {
        var arrow = props.sorted ? props.sortAscending ? React.createElement(arrow_up_closed_14px_small_1.ArrowUp, null) : React.createElement(arrow_down_closed_14px_small_1.ArrowDown, null) : React.createElement("div", { style: { width: '14px' } });
        return (React.createElement("div", { className: ModelResultStyles_1.DataGridHeader },
            React.createElement("div", { className: "".concat(ModelResultStyles_1.DataGridHeaderText, " ").concat(ModelResultStyles_1.DataGridHeaderTextSortable) }, props.col.headerText),
            arrow));
    };
    SortableDataGrid.prototype.render = function () {
        return React.createElement(widgets_datagrid_1.DataGrid, __assign({}, this.state.dataGridProps));
    };
    return SortableDataGrid;
}(React.Component));
exports.SortableDataGrid = SortableDataGrid;
//# sourceMappingURL=SortableDataGrid.js.map